module.exports = __webpack_public_path__ + "static/media/sapp3.9c5a813d.png";